function getRules() {
  return {
    required: value => !!value || "Required",
    textLngth50: v =>
      (v && v.length <= 50) || "Must be less than 50 characters.",
    emailPattern: v => /^.+@.+\..+$/.test(v) || "Enter correct email address",
    emailLength: v =>
      (v && v.length <= 100 && v.length >= 10) ||
      "Email must be at least 10 untill 100 characters.",
    phoneNumberPattern: v =>
      /^[0-9]{9,12}$/.test(v) ||
      "Please enter your phone number with no other symbols or spaces. Just the 9-12 numbers!",
    passwordLength: v =>
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~#?!@$%^&*-]).{6,30}$/.test(
        v
      ) ||
      "Password should be at least 6 until 30 characters and contain at least one lowercase('a'-'z'), one uppercase('A'-'Z'), one digit ('0'-'9') and one non alphanumeric character(~#?!@$%^&*-).",
    nameOnCreditCard: v =>
      (v && v.length <= 50) || "Must be less than 50 characters.",
    standardLength: v =>
      (v && (v.length == 14 || v.length == 16 || v.length == 15)) ||
      "Please enter valid card",
    amexLength: v => (v && v.length == 15) || "Must be 15 digits.",
    expiryDateLength: v => (v && v.length == 4) || "Must be 4 digits.",
    monthValidation: v =>
      (v && parseInt(v[0] + v[1]) <= 12) || "Please enter a valid Month",
    securityCodeLength: v =>
      (v && v.length <= 4 && v.length >= 3) ||
      "Security Code must be 3-4 characters.",
    ccvLength: v =>
      (v && v.length <= 4 && v.length >= 3 && /^[0-9]+$/.test(v)) ||
      "Please enter valid CVV",
    termsMessage: v =>
      !!v || "You must accept the terms of service before you can proceed.",
    zipPattern: v =>
      /^[a-zA-Z0-9]+$/.test(v) || "Please enter valid zip / postal.",
    maxMonths: v => v <= 12 || "",
    maxWeekhours: v => v <= 168 || "",
    businessNameAdmin: v =>
      v.length <= 50 || "Must be less than 50 characters.",
    BriggsLength: v => v.length <= 150 || "",
    slapExpertExperienceDescription: v =>
      v.length <= 140 || "Must be less than 140 characters.",
    isWholeNumber: v => /^[0-9]*$/.test(v) || "Must be whole number",
    isNumber: v => /^[0-9]*$/.test(v) || "Must be number",
    isPercentage: v =>
      (v && parseInt(v) <= 100 && parseInt(v) >= 1) ||
      "Must be less than  or equal to 100%",
    phoneNumberPatternAdmin: v =>
      /^(?:[0-9]{9,12}|)$/.test(v) ||
      "Please enter your phone number with no other symbols or spaces. Just the 9-12 numbers!",
    numberRequired: v => isValueDefined(v) || "Required."
  };
}

/*Convert Date Format to YYYY-MM-DD
    Param: Date in string
  */
function convertDate(str) {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-4),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
}

/*To show toast message for error Message
      params:
          context:Current component context(this) - to able to access the store and router
          errorMessage: content to be shown in the toast message
  */
function commonApiErrorMsg(context, errorResponse) {
  context.$toast.error(errorResponse.systemMessage);
  // context.$store.dispatch("logout").then(() => {
  //   context.$router.push("/login");
  // });
}

function isLocalHost() {
  if (location.origin.indexOf("localhost") !== -1) return true;

  return false;
}

/*Check provided value is valid/not
    Param:Value(any datatype)
  */
function isValueDefined(value) {
  if (value === 0 || value || value === null) {
    return true;
  }
  return false;
}

/*Calcuate time difference in Hours
   params:start Time and End time
  */
function calTimeDiffinHours(dt2, dt1) {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
}

export default {
  getRules,
  convertDate,
  isLocalHost,
  commonApiErrorMsg,
  calTimeDiffinHours
};
